import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_11.png'
import _imports_1 from '@/assets/searh_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6f1015ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no_rem_wh-14 no_rem_ml-12 no_rem_mr-8",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-14 ml-12 mr-6",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = ["onKeyup"]

import {
		ref,
		withDefaults
	} from 'vue';
	import useStore from '../store';
	
	interface PropsType {
		bg?: any
	}
	
	// 子->父
	interface EmitType {
		(e: "change", params: string)
	}
	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'SeachArea',
  props: {
    bg: { default: "#F0F0F0" }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
		(e: "change", params: string)
	}), expose: any, slots: any, attrs: any }) {

const props = __props as { bg: any };

	
	
	const store = useStore;
	let content = ref("");
	
	
	const search = () => {
		emit("change", content.value);
	}

return (_ctx: any,_cache: any) => {
  return (!_unref(store).state.is_phone)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "no_rem_search_area flex-row-center-start",
        style: _normalizeStyle({'background': props.bg})
      }, [
        _hoisted_1,
        _withDirectives(_createElementVNode("input", {
          class: "flex-1 no_rem_search_input co-161A1D",
          placeholder: "搜索你想要的....",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(content) ? (content).value = $event : content = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, _unref(content)]
        ]),
        _createElementVNode("img", {
          class: "no_rem_wh-46-30 no_rem_search_icon pointer",
          onClick: search,
          src: _imports_1,
          alt: ""
        })
      ], 4))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "search_area flex-row-center-start",
        style: _normalizeStyle({'background': props.bg})
      }, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          class: "flex-1 search_input mr-24 co-161A1D",
          onKeyup: _withKeys(search, ["enter"]),
          placeholder: "搜索你想要的....",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(content) ? (content).value = $event : content = $event)),
          type: "text"
        }, null, 40, _hoisted_3), [
          [_vModelText, _unref(content)]
        ])
      ], 4))
}
}

})